<template>
    <div class="over">
        <Header title="个人资料" />
        <div class="header flex ccc">
            <div class="pic-wrap flex ccc pos-r avatar-wrap">
                <van-uploader class="flex ccc" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :after-read="_afterReadPhoto">
                    <van-button class="upload-btn-item" round :icon="userInfo.avatar || Images.img_default_avatar"></van-button>
                </van-uploader>
            </div>
            <p class="avatar-tips">修改头像</p>
        </div>
        <div class="body">
            <div>
                <p>用户编号</p>
                <span>{{userInfo.id}}</span>
            </div>
            <div>
                <p>真实姓名</p>
                <span>{{userInfo.real_name || '未设置'}}</span>
            </div>
            <div>
                <p>昵称</p>
                <input class="text-r flex-1" type="text" v-model="formData.name" @input="changeSubmitStatus" />
            </div>
            <div @click="showDate = true">
                <p>出生日期</p>
                <span>{{formData.birthday || '未设置'}}</span>
            </div>
            <div>
                <p>性别</p>
                <van-popover v-model="showSexPopover" trigger="click" :actions="sexActions" @select="_onSelectSex" placement="bottom-end">
                    <template #reference>
                        <span>{{Constants.sex[formData.sex] || '未设置'}}</span>
                    </template>
                </van-popover>
            </div>
            <div @click="_onPressToNavigate('', 'changeMobile')">
                <p>绑定手机号</p>
                <span>{{userInfo.mobile}}</span>
                <img :src="Images.icon_arrow_right1" alt="">
            </div>
            <div @click="_onPressUnbundleWeChat">
                <p>绑定微信</p>
                <span>{{userInfo.h5_openid ? '已绑定' : '未绑定'}}</span>
                <img :src="Images.icon_arrow_right1" alt="">
            </div>
            <div @click="showArea = true">
                <p>所在城市</p>
                <span>{{formData.area || '未设置'}}</span>
            </div>
        </div>
        <div class="btn" @click="_onPressSubmit">{{canSubmit ? '立即保存' : '返回'}}</div>
        <van-popup v-model="showDate" position="bottom">
            <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" @confirm="_onConfirm" @cancel="showDate = false" />
        </van-popup>
        <PickerArea ref="PickerArea" :show="showArea" @confirm="_onConfirmAddress" @cancel="showArea = false"></PickerArea>
    </div>
</template>
<script>
import {
    mapGetters,
    mapActions,
} from 'vuex'
import moment, { locales } from 'moment';
import Header from '@/components/Header'
import {
    QiniuUpload
} from '@/utils/qiniuUpload'
import PickerArea from '@/components/PickerArea'
export default {
    components: {
        Header,
        PickerArea,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            formData: {
                name: '',
                area: '',
                sex: '',
                birthday: '',
            },
            showArea: false,
            showDate: false,
            canSubmit: false,
            showSexPopover: false,

            currentDate: new Date(),
            minDate: new Date(1900, 0, 1),
            maxDate: new Date(2100, 10, 1),
            sexActions: [{ text: '男', value: '1' }, { text: '女', value: '2' }, { text: '保密', value: '0' }],

            dataSources: {},
            qiniuInfo: {},
            uploaderMaxSize: {},
            avatar_url: '',
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.getQiniuData();
        if (this.userInfo) {
            this.formData = {
                sex: this.userInfo.sex,
                area: this.userInfo.area,
                name: this.userInfo.name,
                birthday: this.userInfo.birthday,
            }
            this.currentDate = this.userInfo.birthday ? new Date(this.userInfo.birthday) : new Date();
        }
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            window.location.href = url;
        },

        changeSubmitStatus() {
            console.log('canSubmit = true---->', 'canSubmit = true');
            this.canSubmit = true;
        },

        // 获取七牛云配置
        async getQiniuData() {
            let url = this.API.qiniuToken;
            let params = {};
            let result = await this.$post(url, params);
            this.qiniuInfo = result;
            this.uploaderMaxSize = result.uploaderMaxSize;
        },

        _initialAvatar() {
            if (this.userInfo) {
                this.avatarFile = [{
                    url: this.userInfo.avatar
                }];
            }
        },
        
        _onOversize(file) {
            console.log('file---->', file);
            this.ToastManager('图片大小不能超过：' + (this.uploaderMaxSize.imageMaxSize / 1024) + 'M');
        },

        _afterReadPhoto(file) {
            console.log('file---->', file);
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_QINIUKODO) {
                QiniuUpload(this.qiniuInfo, file)
                    .then((res) => {
                        console.log('res------------->', res)
                        this.Message({
                            message: "上传中",
                            type: 4,
                            time: 500,
                        });
                        let url = this.qiniuInfo.domain + res.key;
                        this.userInfo.avatar = url;
                        this.avatar_url = url;
                    })
                    .catch((err) => {
                        console.log('err------------->', err)
                    });
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_ALIOSS) {
                this._onUploadImageToAliOss(file);
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_TENCENTCOS) {

            }
        },

        // 上传阿里云
        async _onUploadImageToAliOss(file) {
            let url = this.API.uploadToAliOss;
            let params = {
                file: file.file,
                uid: this.userInfo.id,
            };
            this.Message({
                message: "上传中",
                type: 4,
                time: 500,
            });
            let result = await this.$uploadFormData(url, params);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.avatar_url = result.url;
                this.userInfo.avatar = result.url;
            }
        },

        _onPressUnbundleWeChat() {
            let url = this.API.unbundle_wechat;
            let data = {};
            let params = {
                title: '温馨提示',
                message: '确定要解绑该微信吗？',
            };

            if (!this.userInfo.h5_openid) {
                let wx_data = this.Lockr.get('wx_data');
                url = this.API.binding_wechat;
                data = {
                    unionid: wx_data.unionid,
                    h5_openid: wx_data.h5_openid,
                }
                params.message = '确定要绑定该微信吗？';

                if (!this.$isWeiXin()) {
                    return this.ToastManager('请在微信中绑定');
                }
            }

            this.AlertManager.confirm(params).then(() => {
                this._onSubmitRequest(url, data);
            }).catch((error) => console.log('error---->', error));

        },

        _onConfirm(value) {
            console.log('value---->', value);
            this.showDate = false;
            this.currentDate = value;
            this.formData.birthday = moment(value).format('YYYY-MM-DD');
            this.changeSubmitStatus();
        },

        _onSelectSex(action) {
            console.log('action---->', action);
            this.formData.sex = action.value;
            this.changeSubmitStatus();
        },

        // 地址选择确认
        _onConfirmAddress(res) {
            let _areaTemp = [];
            res.forEach(item => {
                _areaTemp.push(item.name);
            });
            this.showArea = false;
            this.formData.area = _areaTemp.join('/');
            this.changeSubmitStatus();
        },

        async _onPressSubmit() {
            let url = this.API.user_save;
            let data = this.formData;

            if (!this.canSubmit) return this._onBack();

            let result = await this.$post(url, data);
            this.ToastManager(result.msg);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo");
                setTimeout(() => {
                    this._onBack();
                }, 1000);
            }
        },

        async _onSubmitRequest(url, data) {
            let result = await this.$post(url, data);
            this.ToastManager(result.msg);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo");
            }
        },

    },
};
</script>
<style lang="less" scoped>
.header {
    padding: 10px 0;
    position: relative;
    margin: 15px 15px 0;
    border-radius: 10px;
    background: #ffffff;

    .avatar-wrap {
        width: 11rem;
        height: 11rem;
        overflow: hidden;
        border-radius: 50%;

        .van-uploader {
            width: 100%;
            height: 100%;

            .upload-btn-item {
                width: 10rem;
                height: 10rem;

                .van-icon__image {
                    width: 9rem;
                    height: 9rem;
                    min-width: 9rem;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }
        }

        .avatar {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }

        .camera {
            width: 35px;
            height: 29px;
        }

    }

    .avatar-tips {
        font-size: 16px;
        margin-top: 1rem;
        color: #7181EB;
    }

}

.body {
    margin: 15px 15px 0;
    padding: 0 10px;
    background: #ffffff;
    border-radius: 10px;

    >div {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #F3F0EE;

        &:last-of-type {
            border: 0;
        }

        >p {
            font-size: 15;
            color: #666;
            margin-right: 10px;
        }

        >span {
            flex: 1;
            font-size: 15;
            color: #333;
            text-align: right;
        }

        >img {
            width: 8px;
            height: 15px;
            margin-left: 10px;
        }
    }
}

.btn {
    margin: 15px;
    height: 40px;
    background: linear-gradient(225deg, #9cb2f4, #6472e8);
    border-radius: 3px;
    font-size: 15px;
    color: #fff;
    text-align: center;
    line-height: 40px;
}
</style>